import React, { Component } from "react";
import { Link } from "gatsby";
import g from "glamorous";
import { css } from "glamor";
import { Container, Row, Col } from "glamorous-grid";
import { FaMapMarker } from "react-icons/fa/";
import { FaEnvelope } from "react-icons/fa";
import { FaPhone } from "react-icons/fa";
import { FaFacebookF } from "react-icons/fa/";
import { FaTwitter } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";

const mediaQueries = {
  phone: "@media only screen and (max-width: 991px)",
};

const FooterDiv = g.footer({
  color: `white`,
  backgroundColor: `rgb(60, 77, 104)`,
  padding: `3em 0 2em`,
});

const Wrapper = g.div({
  maxWidth: `1200px`,
  margin: `0 auto`,
});

const H4 = g.h4({
  margin: `0 auto 1em`,
  fontWeight: `300`,
  fontSize: `1.5em`,
  letterSpacing: `0.1em`,
  [mediaQueries.phone]: {
    fontSize: `1.35em`,
    textAlign: `center`,
    margin: `.7em auto .4em`,
    letterSpacing: `0.07em`,
  },
});

const Address = g.div({ fontSize: `1em` });

const Ul = g.ul({
  listStyle: `none`,
  margin: `0 !important`,
});

const Li = g.li({
  fontSize: `.95em`,
  [mediaQueries.phone]: {
    textAlign: `center`,
  },
});

const A = g.a({
  color: `white`,
});

const Circle = g.div({
  display: `inline-block`,
  textAlign: `center`,
  width: `44px`,
  height: `44px`,
  margin: `.5em .8em .2em 0`,
  fontSize: `1.4em`,
  border: `2px solid white`,
  borderRadius: `50%`,
  position: `relative`,
  transition: `all 0.2s ease-in-out 0s`,
  ":hover": {
    backgroundColor: `white`,
    transition: `all 0.2s ease-in-out 0s`,
  },
  ":hover svg": {
    color: `#3c4d68`,
    transition: `all 0.2s ease-in-out 0s`,
  },
});

const cssFa = css({
  position: `absolute`,
  top: `50%`,
  left: `50%`,
  transform: `translate(-50%, -50%)`,
  transition: `all 0.2s ease-in-out 0s`,
});

const Copyright = g.div({
  fontSize: `.7em`,
  opacity: `.9`,
});

const cssLink = css({
  color: "white",
  fontSize: `.9em`,
  textDecoration: `none`,
  borderBottom: `none`,
  transition: `all .3s`,
  padding: `0 0 3px 0`,
  margin: `0`,
  position: `relative`,
  "::before": {
    content: " ",
    position: `absolute`,
    width: `100%`,
    height: `1px`,
    bottom: `0`,
    left: `0`,
    backgroundColor: `#fff`,
    visibility: `invisible`,
    transform: `scaleX(0)`,
    transition: `all 0.3s ease-in-out 0s`,
  },
  ":hover": {
    transition: `all .3s`,
    border: `none`,
    background: `none`,
    padding: `0 0 3px 0`,
    margin: `0`,
    "::before": {
      visibility: `visible`,
      transform: `scaleX(1)`,
      transition: `all 0.3s ease-in-out 0s`,
    },
  },
});

export default class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = { language: "francais" };
  }

  render() {
    return (
      <FooterDiv>
        <Wrapper>
          <Container>
            <Row>
              <Col span={{ xs: 12 / 12, lg: 37 / 100 }}>
                <H4>Have a question?</H4>
                <Address>
                  Medical Practice of Dr Cédric Kron
                  <br />
                  Aesthetic, Plastic and Reconstructive Surgery
                  <br />
                  Aesthetic Medicine in Paris
                  <br />
                </Address>
                <Address>
                  <A href="tel:+33145628500" {...cssLink}>
                    <FaPhone
                      size={`17`}
                      css={{ marginRight: `6px` }}
                      style={{ verticalAlign: "text-bottom" }}
                    />
                    (+33) 1 45 62 85 00
                  </A>
                  <br />
                  <Link to="/en/contact-us/" {...cssLink}>
                    <FaEnvelope
                      size={`17`}
                      css={{ marginRight: `6px` }}
                      style={{ verticalAlign: "text-bottom" }}
                    />
                    Send us a message
                  </Link>
                  <br />
                  <a
                    href="https://goo.gl/maps/ZPEQycbj3W42"
                    {...cssLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaMapMarker
                      size={`17`}
                      css={{ marginRight: `6px` }}
                      style={{ verticalAlign: "text-bottom" }}
                    />
                    57 avenue de Villiers - 75017 Paris
                  </a>
                  <br />
                </Address>
                <A
                  href="https://www.facebook.com/DrCedricKron"
                  title="Facebook page of Dr Cédric Kron"
                  target="_blank"
                  rel="noopener"
                >
                  <Circle>
                    <FaFacebookF {...cssFa} />
                  </Circle>
                </A>
                <A
                  href="https://www.instagram.com/docteurkron/"
                  title="Instagram account of the medical practice of Dr Kron M.D."
                  target="_blank"
                  rel="noopener"
                >
                  <Circle>
                    <FaInstagram {...cssFa} />
                  </Circle>
                </A>
                <A
                  href="https://twitter.com/Dr_Kron"
                  title="Twitter account of Dr Cédric Kron, cosmetic surgeon"
                  target="_blank"
                  rel="noopener"
                >
                  <Circle>
                    <FaTwitter {...cssFa} />
                  </Circle>
                </A>
                <A
                  href="https://www.youtube.com/channel/UCCbRUwoTEbXraAeMVIN9DuA"
                  title="Youtube channel of Dr Cédric Kron"
                  target="_blank"
                  rel="noopener"
                >
                  <Circle>
                    <FaYoutube {...cssFa} />
                  </Circle>
                </A>
                <A
                  href="https://www.linkedin.com/in/kron-c%C3%A9dric-28492917/"
                  title="Linkedin profile of Dr Kron M.D."
                  target="_blank"
                  rel="noopener"
                  css={{
                    [mediaQueries.phone]: {
                      display: `none`,
                    },
                  }}
                >
                  <Circle>
                    <FaLinkedinIn {...cssFa} />
                  </Circle>
                </A>
              </Col>
              <Col span={{ xs: 6 / 12, lg: 21 / 100 }}>
                <H4>Treatments</H4>
                <Ul>
                  <Li>
                    <Link {...cssLink} to="/en/face/">
                      Face
                    </Link>
                  </Li>
                  <Li>
                    <Link {...cssLink} to="/en/eyes/">
                      Eyes
                    </Link>
                  </Li>

                  <Li>
                    <Link {...cssLink} to="/en/nose/">
                      Nose
                    </Link>
                  </Li>

                  <Li>
                    <Link {...cssLink} to="/en/ears/">
                      Ears
                    </Link>
                  </Li>

                  <Li>
                    <Link {...cssLink} to="/en/breast/">
                      Breast
                    </Link>
                  </Li>
                  <Li>
                    <Link {...cssLink} to="/en/body-contouring/">
                      Body contouring
                    </Link>
                  </Li>
                  <Li>
                    <Link {...cssLink} to="/en/genital-surgery/">
                      Genital surgery
                    </Link>
                  </Li>
                  <Li>
                    <Link {...cssLink} to="/en/legs/">
                      Legs
                    </Link>
                  </Li>
                  <Li>
                    <Link {...cssLink} to="/en/skin/">
                      Skin
                    </Link>
                  </Li>
                </Ul>
              </Col>
              <Col
                span={{ xs: 4 / 12, lg: 21 / 100 }}
                css={{
                  [mediaQueries.phone]: {
                    display: `none`,
                  },
                }}
              >
                <H4>Procedures</H4>
                <Ul>
                  <Li>
                    <Link {...cssLink} to="/en/hyaluronic-acid/">
                      Hyaluronic acid
                    </Link>
                  </Li>
                  <Li>
                    <Link {...cssLink} to="/en/botox-injections/">
                      Botox
                    </Link>
                  </Li>
                  <Li>
                    <Link {...cssLink} to="/en/plastic-surgery/">
                      Plastic surgery
                    </Link>
                  </Li>
                  <Li>
                    <Link {...cssLink} to="/en/reconstructive-surgery/">
                      Reconstructive surgery
                    </Link>
                  </Li>
                  <Li>
                    <Link {...cssLink} to="/en/lifts/">
                      Surgical Lifts
                    </Link>
                  </Li>
                  <Li>
                    <Link {...cssLink} to="/en/liposuction/">
                      Liposuction
                    </Link>
                  </Li>
                  <Li>
                    <Link {...cssLink} to="/en/implants/">
                      Implants
                    </Link>
                  </Li>
                  <Li>
                    <Link {...cssLink} to="/en/peels/">
                      Peels
                    </Link>
                  </Li>
                  <Li>
                    <Link {...cssLink} to="/en/fat-removal/">
                      Fat removal
                    </Link>
                  </Li>
                </Ul>
              </Col>
              <Col span={{ xs: 6 / 12, lg: 21 / 100 }}>
                <H4>The practice</H4>
                <Ul>
                  <Li>
                    <Link {...cssLink} to="/en/before-after/">
                      Before & after
                    </Link>
                  </Li>
                  <Li>
                    <Link {...cssLink} to="/en/plastic-surgeon-paris/">
                      Titles and diplomas
                    </Link>
                  </Li>
                  <Li>
                    <Link {...cssLink} to="/en/plastic-surgery-practice/">
                      Plastic Surgery Practice
                    </Link>
                  </Li>
                  <Li>
                    <Link {...cssLink} to="/en/consultations/">
                      Consultations
                    </Link>
                  </Li>
                  <Li>
                    <Link {...cssLink} to="/en/medical-team/">
                      Medical team
                    </Link>
                  </Li>
                  <Li>
                    <Link
                      {...cssLink}
                      to="/en/before-plastic-surgery-procedures/"
                    >
                      Recommendations
                    </Link>
                  </Li>
                  <Li>
                    <Link
                      {...cssLink}
                      to="/en/reimbursement-plastic-surgery-procedures/"
                    >
                      Reimbursement - Social security
                    </Link>
                  </Li>
                  <Li>
                    <Link {...cssLink} to="/en/risks-plastic-surgery/">
                      Risks in cosmetic surgery
                    </Link>
                  </Li>

                  <Li>
                    <Link {...cssLink} to="/en/testimonials/">
                      Testimonials
                    </Link>
                  </Li>
                </Ul>
              </Col>
            </Row>
            <Row>
              <Col>
                <Copyright
                  css={{
                    [mediaQueries.phone]: {
                      fontSize: `.7em`,
                      textAlign: `center`,
                      marginTop: `1.3em`,
                    },
                  }}
                >
                  &copy; 2026 Dr Kron - 57 av. de Villiers - 75017
                  Paris&nbsp;-&nbsp;
                  <Link
                    {...cssLink}
                    to="/en/legal-notice/"
                    css={{
                      [mediaQueries.phone]: {
                        display: `none`,
                      },
                    }}
                  >
                    Legal notice
                  </Link>
                </Copyright>
              </Col>
            </Row>
          </Container>
        </Wrapper>
      </FooterDiv>
    );
  }
}
